import { render, staticRenderFns } from "./CoursewareDefaultBlock.vue?vue&type=template&id=76c8242f&"
import script from "./CoursewareDefaultBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareDefaultBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports